import { createContext, useContext } from 'react';

const WizardContext = createContext({});
WizardContext.displayName = 'WizardContext';

export const Provider = WizardContext.Provider;
export const Consumer = WizardContext.Consumer;
export const useWizard = () => useContext(WizardContext);
